import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase/firebase.js";

const deleteAccountFn = httpsCallable(getFunctions(app), "deleteAccount");

export const deleteAccount = async () => {
  await deleteAccountFn();
};
